import React, { useState } from 'react';
import PostDetailPreview from './PostDetailPreview';
import ContentPreviewPopOver from '../components/ContentPreviewPopOver';
import useControlledState from '../utils/useControlledState';

type PostDetailPreviewPopOverProps = {
  postId: string;
  anchor?: string;
  children: React.ReactNode;
  offset?: number;
  onPreviewLoadChange?: (loaded: boolean) => void;
  display?: 'block' | 'inline-block' | 'inline';
  allowCrossAxisFlip?: boolean;
  queryId?: string;
  resultId?: string;
  position?: number;
  placement?: React.ComponentProps<typeof ContentPreviewPopOver>['placement'];
  hoverGroupId?: string;
} & (
  | {
      open?: never;
      onOpenChange?: never;
    }
  | {
      open: boolean;
      onOpenChange?: (open: boolean) => void;
    }
);

const PostDetailPreviewPopOver = ({
  postId,
  anchor,
  children,
  offset,
  onPreviewLoadChange,
  display,
  allowCrossAxisFlip,
  queryId,
  resultId,
  position,
  placement,
  hoverGroupId = 'postDetailPreview',
  open,
  onOpenChange,
}: PostDetailPreviewPopOverProps) => {
  const [isOpen, setIsOpen] = useControlledState({
    defaultValue: false,
    value: open,
    onValueChange: onOpenChange,
  });
  const [isPreviewLoaded, setIsPreviewLoaded] = useState(false);

  const handleOnPreviewLoadChange = (loaded: boolean) => {
    onPreviewLoadChange?.(loaded);
    setIsPreviewLoaded(loaded);
  };

  return (
    <ContentPreviewPopOver
      display={display}
      hidden={!isPreviewLoaded}
      hideOnMobile
      allowCrossAxisFlip={allowCrossAxisFlip}
      offset={offset}
      minWidth={250}
      placement={placement}
      popOver={
        <PostDetailPreview
          postId={postId}
          anchor={anchor}
          onPreviewLoadChange={handleOnPreviewLoadChange}
          queryId={queryId}
          resultId={resultId}
          position={position}
          open={isOpen}
        />
      }
      open={isOpen}
      onOpenChange={setIsOpen}
      hoverGroupId={hoverGroupId}
    >
      {children}
    </ContentPreviewPopOver>
  );
};

export default PostDetailPreviewPopOver;
